import { deepFreeze } from '@js/utils';

const WillDashboard = deepFreeze({
  HOME: {
    ROUTE_NAME: 'WillDashboard',
  },
});

export default WillDashboard;
